import SessionStorage from "common/js/SessionStorage";

export default SessionStorage;